import UnSaveIcon from '../../../assets/images/svgicons/unsave.svg';
import SaveIcon from '../../../assets/images/svgicons/save.svg';
import PlayIcon from '../../../assets/images/svgicons/play.svg';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  Carousel,
} from 'alm-react-components';

// import { useTranslation } from "react-i18next";
import { apis } from '../../../services/alm';
import { useEffect, useLayoutEffect, useState } from 'react';
import { defaultImage } from '../../../lib/utils';
import { useTranslation } from 'react-i18next';
import getLocalizedContent from '../../../lib/getLocalizedMetaData';
import { useNavigate } from 'react-router-dom';
import useLibrarySeeAll from '../../../hooks/useLibrarySeeAll';
import { DateFormat, Tag } from '../../../assets/constants/constants';
import moment from 'moment-timezone';
const LibraryRelatedContent = (props: any) => {
  const [relatedContentData, setRelatedContentData] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { bookMarkresponse, deleteBookMark, addBookMark } = useLibrarySeeAll();

  const { courseId } = props;
  const fetchRelatedContent = async () => {
    const relatedContent = await apis.getRelatedContent(courseId);
    const response = relatedContent.data;
    setRelatedContentData(response);
  };
  useEffect(() => {
    fetchRelatedContent();
  }, [courseId]);

  useEffect(() => {
    fetchRelatedContent();
  }, [bookMarkresponse]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [courseId]);
  const handleRedirection = async (id: any) => {
    window.scrollTo(0, 0);
    const response: any = await apis.getProgramList(id);
    if (response) {
      await apis.userEnroll(id, response?.data?.relationships?.instances?.data[0].id);
    }
    navigate(
      `/home/library/library-course/${id}`, {
      state: {
        courseType: "relatedContent",
        relatedId: courseId,
        from: props.from
      }
    }
    )

  }
  return (
    <>
      {relatedContentData && relatedContentData.length > 0 && (
        <div className="mb-12 xl:px-32 lg:px-8 md:px-8 px-5">
          <h2 className="text-3xl font-barlowLight border-t pt-16"
          dangerouslySetInnerHTML={{
            __html: t('Library.relatedContent'),
          }}/>
          <Carousel className="mt-12">
            <CarouselContent className="lg:flex-row md:flex-col lg:gap-0 md:gap-10">
              {relatedContentData?.map((course: any) => {
                const content = getLocalizedContent(course?.attributes?.localizedMetadata);
                const releaseDate = course?.attributes?.tags
                  ?.filter((item: any) => item?.split(':')[0] === Tag.releaseDate)[0]
                  ?.split(':')[1];
                return (
                  <>
                    <CarouselItem className="landscape:2xl:basis-1/4 landscape:xl:basis-1/4 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2 landscape:sm:basis-1/2 portrait:sm:basis-1/2 md:pl-5">
                      <Card
                        onClick={() =>handleRedirection(course?.id)}
                        className="w-full h-full p-0 bg-fillMidGrayCard cursor-pointer border-cardBorder relative"
                      >
                        <CardHeader className="p-0 min-h-[130px]">
                          <div className={`relative cursor-pointer]`}>
                            {course?.attributes?.imageUrl ? (
                              <img
                                src={course?.attributes?.imageUrl}
                                alt={' '}
                                className="rounded-t-xl w-full h-full aspect-[3/2] object-cover"
                              />
                            ) : (
                              <img
                                src={defaultImage()}
                                alt={' '}
                                className="rounded-t-xl w-full h-full aspect-[3/2] object-cover"
                              />
                            )}
                            <img src={PlayIcon} alt={' '} className="absolute center-icon" />
                          </div>
                        </CardHeader>
                        <CardContent className="mt-4 px-5">
                          <div className="flex flex-row items-start justify-between mt-2 h-full">
                            <div className="flex flex-col justify-between">
                              <div className="flex flex-col">
                                <CardTitle className="text-wrap text-xl lg:text-2xl xl:text-2xl font-barlowMedium leading-normal">
                                  {content?.name}
                                </CardTitle>
                                <p className="lg:text-base xl:text-lg font-opensansRegular mt-2 mb-10 flex-grow">
                                  {content?.description}
                                </p>
                              </div>
                              <p className="text-base font-opensansMedium absolute bottom-6">
                                {/* {formatDate(releaseDate?releaseDate:"")} */}
                                <span className="capitalize">
                                  {releaseDate && moment(releaseDate).isValid()? moment(releaseDate).format(DateFormat): ""}
                                </span>
                              </p>
                            </div>
                            <img
                              onClick={e => {
                                e.stopPropagation();
                                course.attributes?.isBookmarked
                                  ? deleteBookMark(course?.id)
                                  : addBookMark(course?.id);
                              }}
                              src={course?.attributes?.isBookmarked ? SaveIcon : UnSaveIcon}
                              alt="No image"
                              className="ms-5 cursor-pointer"
                            />
                          </div>
                        </CardContent>
                      </Card>
                    </CarouselItem>
                  </>
                );
              })}
            </CarouselContent>
            <div className="carousel-prev-next-box">
              <CarouselPrevious className="carousel-prev-btn top-full mt-5 translate-y-0" />
              <CarouselNext className="carousel-next-btn right-0 top-full bottom-0 mt-5 translate-y-0" />
            </div>
          </Carousel>
        </div>
      )}
    </>
  );
};

export default LibraryRelatedContent;
